import { Component, EventEmitter, OnInit, Output, Injector, OnDestroy } from '@angular/core';
import { NavigationEnd, NavigationStart, Router, RouteReuseStrategy } from '@angular/router';
import { AppConfigService } from '../../core/services/config.service';
import { AppTranslationLoaderService } from 'src/app/core/services/translation-loader.service';
import { LogService } from '../content/sections/websocketclient/notification.services';
import { NotificationService } from '../../core/services/notification/notification.service';
import { ApplicationInfoService } from '../../core/translate/application-info.service';
import { TransactionResult } from '../../core/services/interfaces/transaction-result';
import { AppsInfo } from '../../core/translate/models/app-info';
import { environment } from '../../../environments/environment';
import { NavigationService } from 'src/app/core/components/navigation/navigation.service';
import { TranslateApplicationService } from '../../core/translate/translate-application-service';
import { AppNavigationModel } from '../../navigation/navigation.model';
import { MsAdalAngular6Service } from '@jabilcore/microsoft-adal-angular6';
import { CognitoService } from '../../core/services/cognito/cognito.service';
import { AuthService } from '../../core/services/authentication/auth.service';
import { UserInfoService } from '../content/sections/services/user-info-service';
import { ISites } from '../content/sections/interfaces/ISites';
import { PromiseCallerService } from '../content/sections/services/promise-caller-service';
import { SitesService } from '../content/sections/services/sites-services';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IRoles } from '../content/sections/interfaces/IRoles';
import { RolService } from '../content/sections/services/rol-service';
import { LogssService } from '../content/sections/services/logs-services';
import { IAccessLogsBySite } from '../content/sections/interfaces/IAccessLogsBySite';
import { ToolbarReadyService } from '../content/sections/services/toolbar-ready';
import { EmployeeService } from '../content/sections/services/employee-service';
declare const jQuery: any;

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss']
})

export class AppToolbarComponent {
  userStatusOptions: any[];
  languages: Array<any> = [];
  selectedLanguage: any;
  showLoadingBar: boolean;
  horizontalNav: boolean;
  username: string;
  name: string;
  windowsNT: string;
  employeeNumber: string;
  appName: string;
  appVersion: string;
  private adal: MsAdalAngular6Service;
  loginType: number = window["loginType"];
  isAuthenticated: boolean;
	showSite: boolean;
	formGroup: FormGroup;
	listSites: Array<any> = [];
  pk_site:number = 0;

  constructor(
    private employeeService: EmployeeService,
    private router: Router,
    private appConfig: AppConfigService,
    private translate: TranslateApplicationService,
    private cognitoService: CognitoService,
    private authService: AuthService,
    private applications: ApplicationInfoService,
    private notification: NotificationService,
    private injector: Injector,
    private appNavigationService: NavigationService,
    private userInfoService:UserInfoService,
    private promiseCallerService: PromiseCallerService,
    private sitesService: SitesService,
    private rolService: RolService,
    private formBuilder: FormBuilder,
    private logssService:LogssService,
    private toolbarReadyService: ToolbarReadyService
  ) {
    this.isAuthenticated = false;
    this.formGroup = this.formBuilder.group({
			fk_site: [null, Validators.required],
		});

    if (this.loginType == 1) {
      this.adal = <MsAdalAngular6Service>this.injector.get(MsAdalAngular6Service);

      this.appName = window["configuration"].adalConfiguration.applicationName;
      this.appVersion = window["configuration"].adalConfiguration.applicationVersion;
    }
    else {
      this.appName = window["configuration"].applicationName;
      this.appVersion = window["configuration"].applicationVersion;
    }


    this.languages = applications.languages;

    if (this.languages.length == 0) {
      this.languages.push({
        id: 1,
        title: 'English',
        flag: 'en',
        applicationId: 0
      });

      this.languages.push({
        id: 1,
        title: 'Spanish',
        flag: 'es',
        applicationId: 0
      });

    }

    this.selectLanguage();

    router.events.subscribe(
      (event) => {
        if (event instanceof NavigationStart) {
          this.showLoadingBar = true;
        }
        if (event instanceof NavigationEnd) {
          this.showLoadingBar = false;
        }
      });

    this.appConfig.onSettingsChanged.subscribe((settings) => {
      this.horizontalNav = settings.layout.navigation === 'top';
    });

    let toolbarReadyCalled = false;

    switch (this.loginType) {
      case 1:
        if (this.adal.isAuthenticated) {
          this.isAuthenticated = true;	
          this.username = this.adal.userInfo.userName;
          this.name = this.adal.userInfo.profile.nameComplete;
          this.windowsNT = this.adal.userInfo.profile.WindowsNT;
          this.employeeNumber = this.adal.userInfo.profile.unique_name;

          this.userInfoService.setUserInfo({
            userName: this.username,
            name: this.name,
            windowsNT: this.windowsNT,
            employeeNumber: this.employeeNumber
          });
          
          this.appNavigationService.SetNavigationModel(
				    new AppNavigationModel(),
				  );
        this.GetSites();
        toolbarReadyCalled = true;
        }
        break;
      case 2:
        if (this.cognitoService.IsAuhtenticated()) {
          this.isAuthenticated = true;
          this.cognitoService.getUserInfo().subscribe(result => {
          const realEmail = result['identities'][0].userId;
          this.username = realEmail;
          this.employeeService.GetEmployeeByEmail(realEmail).subscribe(
        (emp: TransactionResult<any>) => {
          if (emp.success && emp.data) {
            this.windowsNT = emp.data.nt_account;
            this.name = emp.data.name;
            this.username = emp.data.email;
            this.employeeNumber = emp.data.workday_id;
            this.userInfoService.setUserInfo({
              userName: emp.data.email,
              name: emp.data.name,
              windowsNT: emp.data.nt_account,
              employeeNumber: emp.data.workday_id
            });
          }
          this.GetSites();
          toolbarReadyCalled = true;
        }
            );
          });
        }
        break;
      case 3:
        if (this.authService.isAuthenticated()) {
          this.username = this.authService.user.email;
          this.name = this.authService.user.name;
          this.windowsNT = this.authService.user.userName;
        }
        break;
    }

    if (this.loginType !== 2 && !toolbarReadyCalled) {
      this.toolbarReadyService.setReady(); 
    } 

  }


  ChangeSite() {
		if (this.adal.isAuthenticated) {
			 this.userInfoService.setUserInfo({ pk_site: this.formGroup.controls.fksite.value});
			jQuery('.btnReload').trigger('click');
			/*La siguiente linea crea todo el menu */
				this.appNavigationService.SetNavigationModel(
					new AppNavigationModel(),
				);
		}
	}

  selectLanguage(): void {
    let indexLang = 0;
    if (this.languages != undefined) {
      if (navigator.language.split('-').length > 0) {
        indexLang = this.languages.findIndex(lang => lang.flag === navigator.language.split('-')[0]);
      }
      else {
        indexLang = this.languages.findIndex(lang => lang.flag === navigator.language);
      }

      if (indexLang < 0) {
        this.selectedLanguage = this.languages[0];
      } else {
        this.selectedLanguage = this.languages[indexLang];
      }

      this.setLanguage(this.selectedLanguage);
    }
  }

  setLanguage(lang) {
    // Set the selected language for toolbar
    this.selectedLanguage = lang;
    // selected language for translations
    this.translate.use(lang);
  }

  logIn(): void{
    switch (this.loginType) {
    case 1:
    this.adal.login();
      break;
    case 2:
      this.cognitoService.logIn();
      break;
    case 3:
      this.authService.login();
      break;
    }
  }

  logOut(): void {
    switch (this.loginType) {
      case 1:
        if (this.adal.isAuthenticated)
          this.adal.logout();
          this.userInfoService.clearUserInfo();
          localStorage.clear();
        break;
      case 2:
        if (this.cognitoService.IsAuhtenticated())
          this.cognitoService.logOut();
        break;
      case 3:
        if (this.authService.isAuthenticated())
          this.authService.logAuth();
        break;
    }
  }

  GetSites(){
    this.listSites = [];
    let first = true;
    this.sitesService.GetSitesByUsername().subscribe(
      (result: TransactionResult<ISites[]>) => {
        if (result.success) {
          if (result.data.length > 0) {
            result.data.forEach((obj) => {
              if (first && this.pk_site == 0) {
                this.userInfoService.setUserInfo({ pk_site: obj.pk_site });
                this.formGroup.controls.fk_site.setValue(obj.pk_site);
                this.pk_site = obj.pk_site;
                this.showSite = true;
                
              }
              if (obj.pk_site == this.pk_site) {
                this.formGroup.controls.fk_site.setValue(obj.pk_site);
                this.showSite = true;
              }
              first = false;
              this.listSites.push(obj);
			      });
            this.GetRol();
            this.appNavigationService.SetNavigationModel(
                new AppNavigationModel(),
              );
          } else {
            this.router.navigateByUrl('/main/without-permission');
          }
				}
			},
			(error: any) => { this.notification.error(error); },
		);
  }
  
  
  GetRol(){
		this.rolService.GetRoleByUser().subscribe(
			(result: TransactionResult<IRoles>) => {
				this.toolbarReadyService.setReady();
				if(result){
					localStorage.setItem('role', result['name']);
				}	
			}
		);
	}


}
